import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import axios from "axios";
import {BankTransferContext} from "../../context/BankTransfer";
import classNames from 'classnames/bind';
import styles from './Sidebar.module.css';
import {Method, MethodKeyType} from '../Method';
import {useContext} from 'react';

import {StatusContext} from '../../context/Status';
import {RoutingContext} from '../../context/Router';
import {acceptedWalletsByCountry, sendMessage} from '../../context/utils';
import {ErrorAlertContext} from "../../context/ErrorAlert";
import {useWallets} from "../../hooks/useWallets";
import { handleOzowZarRedirect } from '../../utils/helperFunctions';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { FEATURE_FLAG_KEYS } from '../../utils/constants';

const cx = classNames.bind(styles);

export const Sidebar = () => {
    const [currencyMethods, setCurrencyMethods] = useState<MethodKeyType[]>([
        'card',
    ]);

    const {currency, payData, merchantKey, } = useContext(RoutingContext);

    const { businessId } = payData.kit

    const { wallets, fetchWallets } = useWallets();

    useEffect(() => {
        if (businessId) {
            fetchWallets(businessId).then(r => r );
        }
    }, [businessId]);

    const enableNewOzowRedirect = useFeatureFlagEnabled(FEATURE_FLAG_KEYS.enableNewOzowRedirect)

    const {onShowAlert} =
        useContext(ErrorAlertContext);
    const location = useLocation();
    const currentPath = location.pathname;


    const {pageTransactionStatus} = useContext(StatusContext);
    const {
        setTransferDetails,
        setTransferDetailsLoading,
        setTransactionRef,
    } = useContext(BankTransferContext);


    useEffect(() => {
        const methods = acceptedWalletsByCountry(payData?.details?.currency, payData.kit, wallets);
        setCurrencyMethods(methods);
    }, [currency, payData.kit, wallets]);


    function handleRedirection(responseData: any) {
        if (responseData && responseData.data && responseData.data.auth_url) {
            window.location.replace(responseData.data.auth_url);
        }
    }

    const pathCheck = currentPath === "/transfer"

    useEffect(() => {
        if(!pathCheck) return

        const getTransferDetails = async () => {
            setTransferDetailsLoading(true);
            try {
                if (currency === 'ZAR') {
                    handleOzowZarRedirect(payData, merchantKey, onShowAlert)
                } else {
                    const payload = {
                        ...payData.kit,
                        paymentType: payData.kit?.paymentType || 'html-checkout',
                        productType: payData.kit?.productType  ?? "COLLECTION",
                    };
                    const response = await axios(
                        `${process.env.REACT_APP_API_URL}pay/${currency}/banktransfer/v2`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "x-auth-token": merchantKey,
                                ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                                    "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                                })
                            },
                            data: payload,
                        }
                    );

                    const responseData = response.data;

                    if (responseData) {
                        if (responseData.data && responseData.data.auth_url) {
                            handleRedirection(responseData)
                        }

                        if (responseData.status === "error") {
                            const errorMessage = responseData.message === "amount should be between 0 and 25,000,000"
                                ? "Amount should be between 1 and 25,000,000"
                                : responseData.message;
                            onShowAlert(responseData, errorMessage);
                            return;
                        }

                        if (responseData.status === "success") {
                            const {authorization} = responseData.meta || {};
                            if (authorization) {
                                setTransferDetails(authorization);
                            }
                            setTransactionRef(responseData.tx_ref);
                        }
                    } else {
                        console.error("Response data is missing or invalid.");
                    }
                }
            } catch (err) {
                // @ts-ignore
                onShowAlert(err, err.error);
            }
            setTransferDetailsLoading(false);
        };
        getTransferDetails();
    }, [currency, merchantKey, payData.kit, currentPath, enableNewOzowRedirect, pathCheck]);


    return (
        <div
            className={cx({
                container: true,
                hide: ['success', 'error', 'pin', 'otp', 'codesent'].includes(
                    pageTransactionStatus
                ),
            })}
        >
            <div className={styles.main}>
                <div className={styles.head}>
                    <p className={styles.header}>Pay with</p>
                </div>
                <div className={styles.body}>
                    {currencyMethods.map((method) => (
                        <Method
                            key={method}
                            methodKey={method}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};